import type { Vec2 } from '../core/types';

/** Rayon (px de jeu) de course du bouton suiveur autour de la base du joystick. */
export const JOYSTICK_RADIUS = 100;
/** Décalage (px de jeu) en dessous duquel le joystick ne bouge pas le joueur. */
export const JOYSTICK_DEADZONE = 12;

/** Vecteur de déplacement (norme <= 1) pour un doigt en `current` et un joystick centré en `base`. */
export function joystickVector(base: Vec2, current: Vec2, radius = JOYSTICK_RADIUS, deadZone = JOYSTICK_DEADZONE): Vec2 {
  const dx = current.x - base.x, dy = current.y - base.y;
  const len = Math.hypot(dx, dy);
  if (len < deadZone) return { x: 0, y: 0 };
  const k = Math.min(len, radius) / radius / len;
  return { x: dx * k, y: dy * k };
}

/** Position du bouton suiveur : le doigt, ramené sur le cercle de rayon `radius` autour de la base. */
export function joystickKnob(base: Vec2, current: Vec2, radius = JOYSTICK_RADIUS): Vec2 {
  const dx = current.x - base.x, dy = current.y - base.y;
  const len = Math.hypot(dx, dy);
  if (len <= radius) return { x: current.x, y: current.y };
  return { x: base.x + dx / len * radius, y: base.y + dy / len * radius };
}
